module.exports = __webpack_public_path__ + "img/blue_135.e4ef79fa.png";